import React from 'react'
import { trim } from 'lodash'
import PropTypes from 'prop-types'
import {
  InputFieldReduxFormWrapper,
  SelectFieldReduxFormWrapper,
  MaskedInputFieldReduxFormWrapper,
  constants as tkConstants,
  utils as tkUtils,
} from '@adc/ui-core'
import { stateOptions } from '../../entityForm/shared/internal'
import { Field } from 'redux-form'
import classnames from 'classnames/bind'
import styles from '../styles.scss'
import { formatTitlelize } from '../../../../util/formatters'
import { capitalizeFirstLetter } from '../utils'

const cx = classnames.bind(styles)

const { required, format } = tkUtils.formValidators

const checkOwnerName = contactFieldValues =>
  !(contactFieldValues.first_name && contactFieldValues.last_name)

const checkOwnerCompany = contactFieldValues => !contactFieldValues.company_name

const getContactInfoNameValidations = contactFieldValues => {
  const isOwnerInformationEmpty = checkOwnerName(contactFieldValues)
  const isCompanyNameEmpty = checkOwnerCompany(contactFieldValues)

  const requiredWithCustomMessage = required({
    msg: 'Please input either your Company Name or First & Last Name.',
  })

  if (isOwnerInformationEmpty && !isCompanyNameEmpty) {
    return {
      companyName: {
        validate: requiredWithCustomMessage,
        required: true,
      },
      firstAndLastName: {},
    }
  }

  return {
    companyName: {},
    firstAndLastName: {
      validate: requiredWithCustomMessage,
      required: true,
    },
  }
}

/*
 * company_name
 * first_name
 * last_name
 * phone
 *
 */
export const ContactInfoFields = ({
  elmId,
  formKey,
  contactFieldValues = {},
}) => {
  const contactInfoNameValidations =
    getContactInfoNameValidations(contactFieldValues)

  return (
    <>
      <div className={cx('field-wrapper')}>
        <Field
          name={`${formKey}.company_name`}
          component={InputFieldReduxFormWrapper}
          label='Company Name'
          elmId={`${elmId}_company_name`}
          normalizeOnBlur={trim}
          normalize={capitalizeFirstLetter}
          type='text'
          {...contactInfoNameValidations.companyName}
        />
      </div>
      <div className={cx('field-wrapper')}>
        <Field
          name={`${formKey}.first_name`}
          component={InputFieldReduxFormWrapper}
          label='First Name'
          elmId={`${elmId}_first_name`}
          normalizeOnBlur={formatTitlelize}
          type='text'
          {...contactInfoNameValidations.firstAndLastName}
        />
      </div>
      <div className={cx('field-wrapper')}>
        <Field
          name={`${formKey}.last_name`}
          component={InputFieldReduxFormWrapper}
          label='Last Name'
          elmId={`${elmId}_last_name`}
          normalizeOnBlur={formatTitlelize}
          type='text'
          {...contactInfoNameValidations.firstAndLastName}
        />
      </div>
    </>
  )
}

ContactInfoFields.propTypes = {
  formKey: PropTypes.string.isRequired,
  elmId: PropTypes.string.isRequired,
  contactFieldValues: PropTypes.object,
}

/* street_address
 * municipality
 * country_primary_subdivision
 * postal_code
 */
export const AddressFields = ({ elmId, formKey }) => {
  return (
    <>
      <div className={cx('field-wrapper')}>
        <Field
          className={cx('field')}
          name={`${formKey}.street_address`}
          component={InputFieldReduxFormWrapper}
          label='Address'
          elmId={`${elmId}_street_address`}
          validate={required()}
          normalizeOnBlur={trim}
          type='text'
          required
        />
      </div>
      <div className={cx('field-wrapper')}>
        <Field
          className={cx('field')}
          name={`${formKey}.municipality`}
          component={InputFieldReduxFormWrapper}
          label='City'
          elmId={`${elmId}_city`}
          validate={required()}
          normalizeOnBlur={trim}
          type='text'
          required
        />
      </div>
      <div className={cx('field-wrapper')}>
        <Field
          className={cx('field')}
          name={`${formKey}.country_primary_subdivision`}
          component={SelectFieldReduxFormWrapper}
          label='State'
          elmId={`${elmId}_state`}
          options={stateOptions(`${formKey}`)}
          validate={required()}
          placeholder='Select'
          required
        />
      </div>
      <div className={cx('field-wrapper')}>
        <Field
          className={cx('field')}
          name={`${formKey}.postal_code`}
          component={MaskedInputFieldReduxFormWrapper}
          label='Zip Code'
          elmId={`${elmId}_zip_code`}
          validate={[
            required(),
            format({
              with: tkConstants.regex.ZIPCODE_SYNTAX,
              msg: 'Invalid Zipcode',
            }),
          ]}
          mask={tkUtils.inputMasks.zipcodeMask}
          type='text'
          required
        />
      </div>
    </>
  )
}

AddressFields.propTypes = {
  formKey: PropTypes.string.isRequired,
  elmId: PropTypes.string.isRequired,
}
